import React from 'react';
import styled from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${flexGap('16px')}
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${flexGap('32px')}
`;

const DescBox = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background: #f4f6fc;
  padding: 24px;
  min-height: 700px;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  ${flexGap('8px')}
`;

const Title = styled.h2`
  font-weight: 600;
  font-size: 40px;
  margin: 0;
  line-height: normal;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${flexGap('32px')}
`;

const Desc = styled.h3`
  font-weight: 400;
  font-size: 16px;
  color: #424748;
  line-height: 1.3;
  margin: 0;
`;

const Link = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 41px;
  background: #fff;
  color: #fff;
  cursor: pointer;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  &:hover {
    color: #050a30;
  }
`;

const PrimaryButton = styled(Link)`
  background: #1f68db;
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  ${flexGap('32px')}
`;

const Benefits = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  ${flexGap('16px')}
`;

const Kinds = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
`;

const Kind = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  ${flexGap('12px')}
  border-bottom: 1px solid #dde2e4;
  padding: 16px;
  &:first-child {
    padding: 16px 8px;
  }
  &:last-child {
    border-bottom: none;
  }
`;

const Img = styled.img`
  width: 24px;
  height: 24px;
`;

const KindDesc = styled.h3`
  font-weight: 600;
  font-size: 20px;
  margin: 0;
  line-height: 1;
`;

const BoldText = styled.span`
  font-weight: 600;
`;

const benefits1 = [
  'Guaranteed Wifi',
  'Availability in less than 24 hours',
  'No User Limits, Fully Transferable',
  'Exclusive Mid Jet Rates',
];

const benefits2 = [
  'Fully Transferable Across 6 Jet Categories',
  'Balance Refundable - Terms Apply',
  'Rates Apply to Transatlantic & Transpacific Routes',
  'Only 29 peak days',
];

const Card = ({
  title,
  descriptions = [],
  ctaText,
  ctaHref,
  benefitsTitle,
  benefits = [],
  benefitIcon = '/imgs/svg/home/done-all-rounded.svg',
}) => {
  return (
    <DescBox>
      <Header>
        {title && (
          <TitleBox>
            <Title>{title}</Title>
          </TitleBox>
        )}
        <Box>
          {descriptions.map((text, i) => (
            <Desc key={i}>{text}</Desc>
          ))}
          {ctaText && ctaHref && <PrimaryButton href={ctaHref}>{ctaText}</PrimaryButton>}
        </Box>
      </Header>

      <Footer>
        {(benefitsTitle || benefits.length > 0) && (
          <Benefits>
            {benefits.length > 0 && (
              <Kinds>
                {benefits.map((item, index) => (
                  <Kind key={index}>
                    <Img src={benefitIcon} alt="benefit" />
                    <KindDesc>{item}</KindDesc>
                  </Kind>
                ))}
              </Kinds>
            )}
          </Benefits>
        )}
      </Footer>
    </DescBox>
  );
};

const Cards = () => {
  return (
    <Container>
      <Card
        title="Coast to Coast Jet Card"
        descriptions={[
          'Experience the next level of private jet travel with our Coast-to-Coast Jet Card-crafted exclusively for the most popular routes, guaranteeing availability and streamlined logistics for every trip.',
          <>
            Fly coast-to-coast for as little as <BoldText>$7,500 per hour</BoldText> on our Mid Jet
            Card or choose from transparent hourly rates across all categories-Mid, Supermid,
            Supermid Plus, and Heavy.
          </>,
        ]}
        ctaText="Inquire now"
        ctaHref="/charterQuote"
        benefits={benefits1}
      />
      <Card
        title="Airacer Preferred Jet Card"
        descriptions={[
          'Start with a 10-hour jet card, offering you the autonomy to fly at your convenience. As you embark on each flight, the hours are deducted from your account.',
          <BoldText>
            Easily top up with additional hours in blocks of 10, 20, 30, 40, or 50 so your travel
            arrangements are always under your control.
          </BoldText>,
        ]}
        ctaText="Inquire now"
        ctaHref="/charterQuote"
        benefits={benefits2}
      />
    </Container>
  );
};

export default Cards;
